import { observable, computed, action } from 'mobx'
import { has } from 'lodash'

import FieldStore from 'stores/field/FieldStore'
import Field from 'stores/field/Field'

export type ISortOrder = 'asc' | 'desc'
export interface IScriptSort {
  fieldId: string | null
  order: ISortOrder
}

export const DEFAULT_SORT_ORDER: ISortOrder = 'asc'

class ScriptSort {
  @observable fieldId: IScriptSort['fieldId']
  @observable order: IScriptSort['order']

  constructor(sort: IScriptSort) {
    this.fieldId = sort.fieldId
    this.order = sort.order
  }

  @computed
  get field(): Field | null {
    return FieldStore.get(this.fieldId)
  }

  @action
  update(sort: Partial<IScriptSort> = {}) {
    has(sort, 'fieldId') && (this.fieldId = sort.fieldId!)
    has(sort, 'order') && (this.order = sort.order!)
  }

  @action
  reset() {
    this.update({
      fieldId: null,
      order: 'asc',
    })
  }
}

export default ScriptSort
